import { createSlice } from "@reduxjs/toolkit";

export const headerSlice = createSlice({
  name: "currentTrack",
  initialState: "HPG",
  reducers: {
    updateTrack: (state, data) => {
      state = data.payload;
      return state;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateTrack } = headerSlice.actions;

export default headerSlice.reducer;
